import { jsx } from 'react/jsx-runtime';
import { makeStyles } from '@material-ui/core/styles';
import { IconLinkVertical } from './IconLinkVertical.esm.js';

const useStyles = makeStyles(
  (theme) => ({
    links: {
      margin: theme.spacing(2, 0),
      display: "grid",
      gridAutoFlow: "column",
      gridAutoColumns: "min-content",
      gridGap: theme.spacing(3)
    }
  }),
  { name: "BackstageHeaderIconLinkRow" }
);
function HeaderIconLinkRow(props) {
  const { links } = props;
  const classes = useStyles();
  return /* @__PURE__ */ jsx("nav", { className: classes.links, children: links.map((link, index) => /* @__PURE__ */ jsx(IconLinkVertical, { ...link }, index + 1)) });
}

export { HeaderIconLinkRow };
//# sourceMappingURL=HeaderIconLinkRow.esm.js.map
